// extracted by mini-css-extract-plugin
export default {"title":"calendar-view_title__sm93L","main_view":"calendar-view_main_view__ij1Hg"};